import { FC, ReactNode } from "react";

/**
 * The `Group` component properties.
 */
export interface GroupProps {
  /**
   * The group checkbox label.
   */
  readonly label?: ReactNode;

  /**
   * The group children.
   */
  readonly children?: ReactNode;
}

/**
 * Groups a series of checkboxes allowing them all to be selected or deselected.
 */
export const Group: FC<GroupProps> = () => {
  return null;
};
